import { LocateStepAction } from './locateStepAction';
import { ScrollStepAction } from './scrollStepAction';
import { MouseStepAction } from './mouseStepAction';
import { TextValidationStepAction } from './textValidationStepAction';
import { EvaluateExpressionStepAction } from './evaluateExpressionStepAction';
import { TextStepAction } from './textStepAction';
import { JsCodeStepAction } from './jsCodeStepAction';
import { JsConditionStepAction } from './jsConditionStepAction';
import { SpecialKeyStepAction } from './specialKeyStepAction';
import { KeyboardShortcutStepAction } from './keyboardShortcutStepAction';
import { SelectOptionStepAction } from './selectOptionStepAction';
import { SubmitStepAction } from './submitStepAction';
import { HoverStepAction } from './hoverStepAction';
import { WheelStepAction } from './wheelStepAction';
import { DropFileStepAction } from './dropFileStepAction';
import { InputFileStepAction } from './inputFileStepAction';
import { NavigationStepAction } from './navigationStepAction';
import { SleepStepAction } from './sleepStepAction';
import { RefreshStepAction } from './RefreshStepAction';
import { ApiStepAction } from './apiStepAction';
import { ExtractTextStepAction } from './extractTextStepAction';
import { PixelValidationStepAction } from './pixelValidationStepAction';
import { CliJsStepAction } from './cliJsStepAction';
import { CliConditionStepAction } from './cliConditionStepAction';
import { NodePackageStepAction } from './nodePackageStepAction';
import { ExtensionOnlyStepAction } from './extensionOnlyStepAction';
import { SfdcStepAction } from './sfdcStepAction';
import { SfdcRecordedStepAction } from './sfdcRecordedStepAction';
import { SfdcInternalTestStepAction } from './sfdcInternalTestStepAction';
import type { WebDriver } from '../webdriver';
import type { StepActionFactory } from 'clickim/src/background/stepActions/stepActionFactory';


function register(stepActionByType: typeof STEP_ACTION_MAPPING, stepActionFactory: StepActionFactory) {
    (Object.keys(stepActionByType) as (keyof typeof STEP_ACTION_MAPPING)[]).forEach(type => {
        stepActionFactory.registerStepAction(type, stepActionByType[type] as any);
    });
}

const STEP_ACTION_MAPPING = {
    locate: LocateStepAction,
    scroll: ScrollStepAction,
    mouse: MouseStepAction,
    submit: SubmitStepAction,
    text: TextStepAction,
    'special-key': SpecialKeyStepAction,
    'user-code': JsCodeStepAction,
    'validation-code-step': JsCodeStepAction,
    'wait-for-code-step': JsCodeStepAction,
    'action-code-step': JsCodeStepAction,
    'condition-step': JsConditionStepAction,
    'skip-code-step': JsConditionStepAction,
    'element-code-step': JsConditionStepAction,
    'evaluate-expression': EvaluateExpressionStepAction,
    'text-validation': TextValidationStepAction,
    'wait-for-text-validation': TextValidationStepAction,
    'select-option': SelectOptionStepAction,
    'drop-file': DropFileStepAction,
    'input-file': InputFileStepAction,
    hover: HoverStepAction,
    navigation: NavigationStepAction,
    wheel: WheelStepAction,
    sleep: SleepStepAction,
    refresh: RefreshStepAction,
    'keyboard-shortcut-step': KeyboardShortcutStepAction,
    'api-validation': ApiStepAction,
    'api-action': ApiStepAction,
    'api-code-step': JsCodeStepAction,
    'extract-text': ExtractTextStepAction,
    'simple-ui-verification': PixelValidationStepAction,
    'wait-for-simple-ui-verification': PixelValidationStepAction,

    'cli-validation-download-file': ExtensionOnlyStepAction,
    'cli-wait-for-download-file': ExtensionOnlyStepAction,
    'network-validation-step': ExtensionOnlyStepAction,

    'cli-validation-code-step': CliJsStepAction,
    'cli-wait-for-code-step': CliJsStepAction,
    'cli-action-code-step': CliJsStepAction,
    'cli-api-code-step': CliJsStepAction,

    'cli-condition-step': CliConditionStepAction,
    'node-package': NodePackageStepAction,

    'email-code-step': JsCodeStepAction,
    'cli-email-code-step': CliJsStepAction,

    'sfdc-internal-test-step': SfdcInternalTestStepAction,
    'sfdc-recorded-step': SfdcRecordedStepAction,
    'sfdc-step-login': SfdcStepAction,
    'sfdc-step-loginas': SfdcStepAction,
    'sfdc-step-logout': SfdcStepAction,
    'sfdc-step-sobjectcreate': SfdcStepAction,
    'sfdc-step-sobjectdelete': SfdcStepAction,
    'sfdc-step-findrecord': SfdcStepAction,
    'sfdc-step-quickaction': SfdcStepAction,
    'sfdc-step-sobjectedit': SfdcStepAction,
    'sfdc-step-sobjectvalidate': SfdcStepAction,
    'sfdc-step-launchapp': SfdcStepAction,
    'sfdc-step-wait-for-page-load': SfdcStepAction,
    'sfdc-step-closeconsoletabs': SfdcStepAction,
    'sfdc-step-relatedlistaction': SfdcStepAction,
    'sfdc-step-permission-validation': SfdcStepAction,
    'sfdc-step-convert-lead-to-opportunity': SfdcStepAction,
    'sfdc-step-quotelineeditor': SfdcStepAction,
    'sfdc-document-validation': ExtensionOnlyStepAction,
    'sfdc-step-flow-screen-completion': SfdcStepAction,
    'sfdc-step-sobjectverifyoptions': SfdcStepAction,
};

export function stepActionRegistrar(driver: WebDriver, stepActionFactory: StepActionFactory) {
    register(STEP_ACTION_MAPPING, stepActionFactory);
    stepActionFactory.registerLocateStepActionUtils(LocateStepAction.getUtils(driver));
}
